const BlueGradient = ({ className }: { className?: string }) => {
  return (
    <div 
      className={`w-[1500px] h-[900px] sm:w-[2420px] sm:h-[1650px] -z-20 gradient ${className}`}
      style={{ transform: 'translateZ(0)', willChange: 'filter' }}
    ></div>
  );
};
const WhiteGradient = ({ className }: { className?: string }) => {
  return (
    <div 
      className={`w-[70vw] h-[60vh] sm:w-[1154px] sm:h-[732px] -z-30 absolute top-0 right-0 sm:-right-10 gradient-white  ${className} `}
      style={{ transform: 'translateZ(0)', willChange: 'filter' }}
    ></div>
  );
};
const LightBLueGradient = ({ className }: { className?: string }) => {
  return (
    <div 
      className={`w-[80vw] h-[70vh] sm:w-[1043px] sm:h-[1024px] -z-20 absolute top-0 left-0 sm:-left-20 bg-[#075480] gradient-light-blue  ${className} `}
      style={{ transform: 'translateZ(0)', willChange: 'filter' }}
    ></div>
  );
};

export const Gradients = () => {
  return (
    <div className="w-full -z-40 absolute top-0 left-0 flex flex-col justify-center items-center">
      <div className="relative w-full h-screen">
        <LightBLueGradient/>
        <WhiteGradient/>
      </div>

      <BlueGradient />
      <BlueGradient className="mt-[120px] ml-[600px] sm:block hidden" />
      <BlueGradient className="sm:block hidden" />
    </div>
  );
};
